
import { SearchMatcher } from './CoreUtils';
import { PropertyObject } from '../lib/memoTypes';
import { documentIdRange } from '../db/DocumentStore';
import { ProgressBar } from "../DomMenu";
import { UiContext } from "./UiContext";

export class MemoItemSearchMatcher extends SearchMatcher {
    defaultIgnoreKeys = new Set(['document', 'border', 'backgroundColor', 'x', 'y', 'width', 'height', 'ct', 'cu', 'mt', 'mu', 'lmt', 'textAlign', 'ref',]);
    limitToDocument? : string;
    shortcut? : IDBKeyRange;
    checkForString = null;
    static transformSearch(checkFor: string): string {  //  inline docid_regex:
        let m = checkFor.match(/^([a-z0-9]{2,16}\/[a-zA-Z0-9/-]{2,64})#([a-zA-Z0-9-]+)$/);
        if (m) return 'document=' + m[1] + ' id=' + m[2];
        return checkFor;
    }
    constructor(checkFor:string) {
        super(MemoItemSearchMatcher.transformSearch(checkFor));
        this.checkForString = checkFor;
    }
    transformToken(s: string): string {
        if (s.startsWith('#')) { s = 'tags=/\\b'+s.substring(1)+'\\b'; }
        else if (s === '.') { s = 'document=' + (UiContext.instance.sel as any).activeMemo.documentId; }
        else if (s.startsWith('doc=')) { s = 'document=' + s.substring(4); }
        
        if (/^document=~\/[a-z]/.test(s)) { this.limitToDocument = localStorage.loginUser + s.substring(10); return undefined; }
        if (/^document=[a-z]/.test(s)) { this.limitToDocument = s.substring(9); }
        if (/^id=[a-z0-9]/.test(s) && this.limitToDocument) { this.shortcut = IDBKeyRange.only([ this.limitToDocument, s.substring(3) ]); }
        return super.transformToken(s);
    }
    async performSearch(limit?: number, explain = false, cancel?: AbortSignal): Promise<PropertyObject[]> {
        using _ = this.limitToDocument ? null : ProgressBar.show(`searching for ${this.checkForString}...`);
        const perfLabel = "MemoItemSearchMatcher: " + this.checkForString + (this.limitToDocument ? ` [doc: ${this.limitToDocument}]` : `[ALL DOCS!]`) + ` [limit: ${limit}]`;
        console.time(perfLabel);
        const result = await UiContext.instance.db.searchItems((cursor) => {
            if (explain) {
                const res = this.explainMatch(cursor.value);
                return res ? [ res, cursor.value ] : false;
            } else {
                return this.isMatch(cursor.value);
            }
        }, this.shortcut || (this.limitToDocument ? documentIdRange(this.limitToDocument) : undefined), limit, cancel);
        console.timeEnd(perfLabel);
        return result;
    }
}

export async function getTitleOfURL(url): Promise<string> {
    using _ = ProgressBar.show("retrieving page title");
    try {       // HACK HACK HACK ... do this properly at some point
        // either a proper callback into macro code
        // or a dedicated server function to fetch the title of a page
        if (url.startsWith('https://'))
            return new TextDecoder().decode((await (window as any).pinboard.corsFetch(url, {})).body).match(/<title>(.*?)<\/title>/si)[1];
    } catch {
    }
    return '';
}
